// Additional JavaScript for slider functionality if needed
// This file is referenced by the logo slider section
// The main functionality is already included inline in the section

document.addEventListener('DOMContentLoaded', function () {
  // The main slider functionality is included directly in the section
  // This file is here for potential future extensions

  // Touch support for sliders
  function addTouchSupport() {
    const sliders = document.querySelectorAll('.logo-slider__container');

    sliders.forEach((slider) => {
      let startX = 0;
      let currentX = 0;
      let isDragging = false;
      let sliderWidth = 0;
      let slideWidth = 0;
      let maxSlide = 0;
      let currentSlide = 0;

      // Get slider specific information
      const sliderId = slider.id;
      const slidesCount = parseInt(slider.getAttribute('data-slides-count') || 0);
      const slidesToShow = parseInt(slider.getAttribute('data-slides-to-show') || 1);
      const mobileSlidesToShow = parseInt(slider.getAttribute('data-mobile-slides-to-show') || 1);
      const isMobile = window.innerWidth < 750;
      const activeSlidesToShow = isMobile ? mobileSlidesToShow : slidesToShow;

      // Calculate widths
      function calculateWidths() {
        sliderWidth = slider.offsetWidth;
        slideWidth = sliderWidth / activeSlidesToShow;
        maxSlide = Math.max(0, slidesCount - activeSlidesToShow);
      }

      calculateWidths();

      // Touch start
      slider.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX;
          isDragging = true;
          slider.style.transition = 'none';
          calculateWidths();
        },
        { passive: true }
      );

      // Touch move
      slider.addEventListener(
        'touchmove',
        function (e) {
          if (!isDragging) return;

          const x = e.touches[0].clientX;
          const diffX = x - startX;

          // Calculate temp position
          const moveX = -currentSlide * slideWidth + diffX;

          // Apply transform with boundary limits
          if (moveX <= 0 && moveX >= -maxSlide * slideWidth) {
            slider.style.transform = `translateX(${moveX}px)`;
          }

          currentX = x;
        },
        { passive: true }
      );

      // Touch end
      slider.addEventListener('touchend', function () {
        if (!isDragging) return;

        isDragging = false;
        slider.style.transition = `transform ${parseInt(
          slider.closest('[id^="LogoSlider"]').dataset.sliderSpeed || 500
        )}ms ease`;

        const diffX = currentX - startX;
        const movePercentage = Math.abs(diffX) / slideWidth;

        // Determine if we should change slide (if moved more than 20% of slide width)
        if (movePercentage > 0.2) {
          if (diffX > 0 && currentSlide > 0) {
            // Moved right - go to previous slide
            currentSlide--;
          } else if (diffX < 0 && currentSlide < maxSlide) {
            // Moved left - go to next slide
            currentSlide++;
          }
        }

        // Update dots if they exist
        const sliderId = slider.id.replace('Container', 'Dots');
        const dots = document.querySelectorAll(`#${sliderId} .logo-slider__dot`);

        dots.forEach((dot, index) => {
          if (index === currentSlide) {
            dot.classList.add('logo-slider__dot--active');
          } else {
            dot.classList.remove('logo-slider__dot--active');
          }
        });

        // Snap to the closest slide
        slider.style.transform = `translateX(${-currentSlide * slideWidth}px)`;
      });
    });
  }

  // Add touch support
  addTouchSupport();

  // Update on resize
  window.addEventListener('resize', function () {
    addTouchSupport();
  });
});
